import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {DesignServicesModel} from './DesignServicesModel';
import {CurrencyModel} from './CurrencyModel';
import {ProviderModel} from './ProviderModel';
import {UnitsModel} from './UnitsModel';
import {PriceRangeModel} from './PriceRangeModel';
import {ChargingMethodologyModel} from './ChargingMethodologyModel';
import {SizeModel} from './SizeModel';
import {SiteModel} from './SiteModel';

export class ContractualDataModel {
  id: number = null;
  numAnnoMese: number = null;
  region: RegionModel;
  localCustomer: LocalCustomerModel = null;
  resourceUnit: ResourcesUnitModel = null;
  contractType: ContractTypeModel = null;
  designServices: DesignServicesModel = null;
  units: UnitsModel = null;
  currency: CurrencyModel = null;
  chargingMethodology: string = null;
  chargingMethodologyObject: ChargingMethodologyModel;
  resourceUnitObject: ResourcesUnitModel;
  compensationPayment: number;
  terminationFee: number;
  bmc: number = null;
  bmv: number = null;
  arc: number = null;
  arc2: number = null;
  rrc: number = null;
  rrc2: number = null;
  size: SizeModel = null;
  site: SiteModel = null;
  numAnnoMeseFrom: number = null;
  numAnnoMeseTo: number = null;
  provider: ProviderModel = null;
  priceRangeList: Array<PriceRangeModel> = null;
  pxq: number = null;
  bandwidth1: number = null;
  bandwidth2: number = null;
}

export class ContractualDataReportModel extends  ContractualDataModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}

